/**
 * Hook pour acceder a l'etat brut de la session
 *
 * Pour le code infrastructure qui a besoin du status, du user, de l'account,
 * ou des actions de lifecycle (initialize, reset, refreshSession).
 *
 * @module useSession
 * @author Equipe Brydge
 * @since 3.0.0
 */

import {useMemo} from 'react';
import useSessionStore from 'packages/common/stores/sessionStore';

export const useSession = () => {
  const status = useSessionStore((s) => s.status);
  const user = useSessionStore((s) => s.user);
  const account = useSessionStore((s) => s.account);
  const initialize = useSessionStore((s) => s.initialize);
  const reset = useSessionStore((s) => s.reset);
  const refreshSession = useSessionStore((s) => s.refreshSession);

  return useMemo(() => ({
    status,
    user,
    account,
    initialize,
    reset,
    refreshSession,
  }), [status, user, account, initialize, reset, refreshSession]);
};
